module.exports = __webpack_public_path__ + "img/Dredd_Splash.aa6403a8.jpg";